import React from 'react'
import { useTranslation } from 'react-i18next'
import './index.css'

export type TabType = 'guests' | 'floorPlan' | 'pozivnica'

interface Props {
	activeTab: TabType
	onTabChange: (tab: TabType) => void
	unassignedCount: number
}

const MobileTabBar: React.FC<Props> = ({ activeTab, onTabChange, unassignedCount }) => {
	const { t } = useTranslation('planner')

	return (
		<div className='mobile-tab-bar'>
			<button
				className={`tab-button ${activeTab === 'guests' ? 'active' : ''}`}
				onClick={() => onTabChange('guests')}
			>
				<svg viewBox='0 0 24 24' width='24' height='24' className='tab-icon'>
					<path
						fill='currentColor'
						d='M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z'
					/>
				</svg>
				<span className='tab-label'>{t('tabs.gosti')}</span>
				{unassignedCount > 0 && (
					<span className='tab-badge'>{unassignedCount}</span>
				)}
			</button>

			<button
				className={`tab-button ${activeTab === 'floorPlan' ? 'active' : ''}`}
				onClick={() => onTabChange('floorPlan')}
			>
				<svg viewBox='0 0 24 24' width='24' height='24' className='tab-icon'>
					<path
						fill='currentColor'
						d='M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9 17H7v-7h2v7zm4 0h-2V7h2v10zm4 0h-2v-4h2v4z'
					/>
				</svg>
				<span className='tab-label'>{t('tabs.plan')}</span>
			</button>

			<button
				className={`tab-button ${activeTab === 'pozivnica' ? 'active' : ''}`}
				onClick={() => onTabChange('pozivnica')}
			>
				<svg viewBox='0 0 24 24' width='24' height='24' className='tab-icon'>
					<path
						fill='currentColor'
						d='M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4-8 5-8-5V6l8 5 8-5v2z'
					/>
				</svg>
				<span className='tab-label'>{t('tabs.pozivnica')}</span>
			</button>
		</div>
	)
}

export default MobileTabBar
